import React from 'react';
import '../css/NoEventModal.css';

const NoEventModal = ({ date, isOpen, onClose }) => {
  if (!isOpen || !date) return null;

  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getMotivationalMessage = () => {
    const messages = [
      "No events today, but every day is a chance to make something great!",
      "A quiet day is perfect for planning your next big move!",
      "No events scheduled, but that doesn't mean you can't create your own adventure!",
      "Sometimes the best days are the ones with no plans - time to be spontaneous!",
      "No events today, but every moment is an opportunity waiting to happen!",
      "A free day is a gift - use it wisely!",
      "No scheduled events, but that's when the best ideas often come to life!"
    ];
    return messages[Math.floor(Math.random() * messages.length)];
  };

  return (
    <div className="no-event-modal-overlay" onClick={onClose}>
      <div className="no-event-modal" onClick={e => e.stopPropagation()}>
        <div className="no-event-modal-header">
          <h2 className="no-event-modal-title">
            📅 {formatDate(date)}
          </h2>
          <button className="no-event-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="no-event-modal-content">
          
          <h3 className="no-event-main-message">No Events Scheduled</h3>
          
          <p className="no-event-description">
            {getMotivationalMessage()}
          </p>
          
          
          <div className="no-event-actions">
            {/* <button className="no-event-action-btn primary" onClick={onClose}>
              <span className="btn-icon">✅</span>
              <span className="btn-text">Got it!</span>
            </button> */}
            <button className="no-event-action-btn secondary" onClick={onClose}>
              <span className="btn-icon">📅</span>
              <span className="btn-text">Check other dates</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoEventModal;
